import React from 'react'

type Props = React.SVGProps<SVGSVGElement>;

export const ExInviteIcon = ({ width = 40, height = 40, ...props }: Props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox={`0 0 132 132`}
            {...props}
        >
            <path
                style={{
                    fill: "#7b8280",
                    fillRule: "evenodd",
                    stroke: 'none',

                }}
                d="m0,64.97a65.13,65.13 0 0 0 111.53,45.6c11.95,-12.2 19,-29.3 18.44,-46.46c0.16,-17.15 -7.52,-33.96 -19.64,-45.87a65.07,65.07 0 0 0 -110.34,46.73l0.01,0zm26.95,35.83l77.09,0a51.13,51.13 0 0 0 -4.08,-16.51c-0.73,-1.77 -1.7,-3.44 -2.59,-5.13c-0.86,-1.37 -1.84,-2.98 -2.74,-4.2a38.11,38.11 0 0 0 -6.21,-6.88a38.66,38.66 0 0 0 -5.5,-4.09a32.23,32.23 0 0 0 -9.54,-4.02c-1.84,-0.34 -3.64,-1.01 -5.55,-0.89c-1.99,0.05 -3.99,-0.06 -5.98,0.05a33.86,33.86 0 0 0 -13.89,4.93c-1.59,0.92 -2.99,2.1 -4.46,3.15c-1.16,1.09 -2.42,2.19 -3.52,3.37a45.98,45.98 0 0 0 -4.98,6.38a44.39,44.39 0 0 0 -2.96,5.18a52.51,52.51 0 0 0 -5.09,18.66zm21.98,-52.88c0.6,0.12 1.01,1 1.4,1.32c0.64,0.69 1.32,1.39 2.01,2.11c0.33,0.26 0.64,0.54 1.04,0.84c0.41,0.28 0.8,0.45 0.87,1.05a6.71,6.71 0 0 1 2.43,1.04a7.58,7.58 0 0 0 1.33,0.57c0.41,0.13 0.93,0.22 1.05,0.62c0.79,0.12 1.59,0.24 2.37,0.39c0.64,0.31 1.87,0.08 2.09,0.64c1.29,-0.01 2.59,0.04 3.86,-0.06c0.48,-0.41 1.67,-0.36 2.43,-0.64a13.57,13.57 0 0 0 1.86,-0.35c0.75,-0.49 1.7,-0.67 2.56,-1.13c0.82,-0.36 1.57,-1.05 2.51,-1.08c0.18,-0.59 0.7,-0.94 1.27,-1.38a16.79,16.79 0 0 0 2.04,-1.96c0.18,-0.14 0.37,-0.46 0.56,-0.49c0.01,-0.34 0.4,-0.5 0.62,-0.84c0.19,-0.31 0.34,-0.65 0.83,-0.65c0.24,-1.48 1.43,-2.63 1.81,-4.06c0.59,-0.45 0.49,-1.75 0.75,-2.36s0.16,-1.78 0.71,-1.99l0,-4.13a7.27,7.27 0 0 0 -0.09,-1.48c-0.38,-0.41 -0.38,-1.5 -0.65,-2.16a8.83,8.83 0 0 0 -1.09,-3.21c-0.44,-1.01 -1.32,-2.07 -1.44,-3.1l-0.68,-0.18c-0.1,-0.6 -0.72,-1.06 -1.03,-1.53c-0.42,-0.51 -1.15,-0.97 -1.2,-1.56a3.48,3.48 0 0 1 -1.33,-0.91c-0.37,-0.35 -0.96,-0.67 -1.07,-1.15a5.76,5.76 0 0 1 -2.28,-0.97c-0.37,-0.18 -0.79,-0.43 -1.14,-0.55s-0.79,-0.16 -0.88,-0.54c-0.73,-0.12 -1.68,-0.43 -2.57,-0.51c-0.66,-0.34 -2,-0.09 -2.23,-0.69c-1.29,0.05 -2.6,-0.07 -3.88,0.05a3.7,3.7 0 0 1 -1.23,0.37a15.54,15.54 0 0 0 -4.33,1.13c-1.38,0.3 -2.66,1.6 -3.96,1.71c-0.1,0.48 -0.7,0.79 -1.1,1.16a3.38,3.38 0 0 1 -1.3,0.9c-0.08,0.68 -0.81,1.02 -1.19,1.54c-0.37,0.55 -0.93,0.93 -1.05,1.56l-0.68,0.17c-0.18,1.26 -1.43,2.61 -1.8,4.05c-0.58,0.43 -0.48,1.68 -0.73,2.26c-0.33,0.67 -0.2,1.87 -0.73,2.1l0,4.03a8.91,8.91 0 0 0 0.07,1.48a8.02,8.02 0 0 1 0.65,2.18a8.18,8.18 0 0 0 1.1,3.24a12.31,12.31 0 0 1 1.44,3.15z"
            />
            <path
                style={{

                    fill: "#7b8280",
                    fillRule: "evenodd",
                    transform: "translate(-219.497 -162.433)",
                    stroke: 'none',
                }}

                d="m264.99,196.61l0.34,0l0,-0.51l-0.34,0l0,0.51zm39.66,0l0.34,0l0,-0.51l-0.34,0l0,0.51z" />

            <path
                style={{

                    fill: "#7b8280",
                    fillRule: "evenodd",
                    // transform: "translate(-219.497 -188.939)",
                    stroke: 'none',
                }}

                d="m264.99,228.61l0.34,0l0,-0.51l-0.34,0l0,0.51zm39.66,0l0.34,0l0,-0.51l-0.34,0l0,0.51z" />

            <path
                style={{

                    fill: "#7b8280",
                    fillRule: "evenodd",
                    // transform: "translate(-260.084 -255.203)",
                    stroke: 'none',

                }}


                d="m313.99,308.14a0.83,0.83 0 0 1 0.17,0.47l0.35,0l0,-0.34a1.13,1.13 0 0 1 -0.52,-0.17l0,0.04zm23.01,0.47c-0.03,-0.16 0.13,-0.38 0.08,-0.51a0.6,0.6 0 0 1 -0.43,0.17a0.29,0.29 0 0 0 0.35,0.34z" />
            <path
                style={{

                    fill: "#7b8280",
                    fillRule: "evenodd",
                    // transform: "translate(-235.227 -121.018)",
                    stroke: 'none',

                }}
                d="m284.33,146.61c-0.03,-0.16 0.13,-0.38 0.08,-0.51a0.6,0.6 0 0 1 -0.43,0.17a0.29,0.29 0 0 0 0.35,0.34zm32.62,-0.47a0.83,0.83 0 0 1 0.17,0.47l0.34,0l0,-0.34a1.13,1.13 0 0 1 -0.51,-0.17l0,0.04z" />

            <path
                style={{

                    fill: "#7b8280",
                    fillRule: "evenodd",
                    // transform: "translate(-260.084 -96.169)",
                    stroke: 'none',

                }}
                d="m313.99,116.55c0.16,0.02 0.32,-0.11 0.51,-0.11l0,-0.34l-0.34,0c0.03,0.2 -0.07,0.31 -0.17,0.45zm23.09,0.06c0.04,-0.16 -0.1,-0.31 -0.08,-0.51l-0.35,0c-0.02,0.32 0.27,0.37 0.43,0.52l0,-0.01z" />


            <path
                style={{

                    fill: "#7b8280",
                    fillRule: "evenodd",
                    // transform: "translate(-235.206 -230.354)",
                    stroke: 'none',

                }}

                d="m284.3,278.44l0,-0.34l-0.34,0a0.28,0.28 0 0 0 0.34,0.34zm33.14,0l0,-0.34l-0.34,0a0.28,0.28 0 0 0 0.34,0.34z" />
            <path
                style={{
                    fill: "#7b8280",
                    fillRule: "evenodd",
                    // transform: "translate(-225.295 -141.725)",
                    stroke: 'none',

                }}
                d="m271.99,171.15c0.06,0.13 0.25,0.06 0.34,0.04a2.23,2.23 0 0 0 -0.34,-0.09l0,0.05zm37.26,0c0.05,0.13 0.25,0.06 0.34,0.04a2.23,2.23 0 0 0 -0.34,-0.09l0,0.05z" />

            <path
                style={{
                    fill: "#7b8280",
                    fillRule: "evenodd",
                    // transform: "translate(-281.682 -86.229)",
                    stroke: 'none',

                }}
                d="m340.14,104.44a0.86,0.86 0 0 0 0.08,-0.34c-0.15,0.01 -0.18,0.13 -0.14,0.25l0.06,0.09zm14.08,0a0.86,0.86 0 0 0 0.08,-0.34c-0.15,0.01 -0.18,0.13 -0.14,0.25l0.06,0.09z" />

            <path
                style={{
                    fill: "#7b8280",
                    fillRule: "evenodd",
                    // transform: "translate(-305.614 -271.77)",
                    stroke: 'none',

                }}
                d="m369.48,328.44l0,-0.34l-0.52,0c-0.04,0.29 0.15,0.37 0.38,0.34l0.14,0zm3.78,0l0,-0.34l-0.52,0c-0.04,0.29 0.15,0.37 0.38,0.34l0.14,0z" />
            <path
                style={{
                    fill: "#7b8280",
                    fillRule: "evenodd",
                    // transform: "translate(-225.295 -211.303)",
                    stroke: 'none',

                }}
                d="m271.99,255.15c0.06,0.13 0.25,0.06 0.34,0.04a2.22,2.22 0 0 0 -0.34,-0.09l0,0.05zm37.26,0c0.05,0.13 0.25,0.06 0.34,0.04a2.22,2.22 0 0 0 -0.34,-0.09l0,0.05z" />
            <path
                style={{
                    fill: "#7b8280",
                    fillRule: "evenodd",
                    // transform: "translate(-305.703 -271.77)",
                    stroke: 'none',

                }}
                d="m369.14,328.44a0.86,0.86 0 0 0 0.08,-0.34c-0.15,0.01 -0.18,0.13 -0.14,0.25l0.06,0.09zm4.12,0a0.86,0.86 0 0 0 0.09,-0.34c-0.16,0.01 -0.19,0.13 -0.15,0.25l0.06,0.09z" />

            <path
                style={{
                    fill: "#7b8280",
                    fillRule: "evenodd",
                    // transform: "translate(-304.786 -80.431)",
                    stroke: 'none',

                }}
                d="m368.48,97.44l0,-0.34l-0.52,0c-0.04,0.28 0.15,0.37 0.38,0.34l0.14,0zm4.12,0l0,-0.34l-0.52,0c-0.04,0.28 0.15,0.37 0.38,0.34l0.14,0z" />
            <path
                style={{
                    fill: "#7b8280",
                    fillRule: "evenodd",
                    // transform: "translate(-306.531 -80.431)",
                    stroke: 'none',

                }}
                d="m370.14,97.44a0.86,0.86 0 0 0 0.08,-0.34c-0.15,0.01 -0.18,0.13 -0.14,0.25l0.06,0.09zm3.78,0a0.86,0.86 0 0 0 0.08,-0.34c-0.15,0.01 -0.18,0.13 -0.14,0.25l0.06,0.09z" />
            <path
                style={{
                    fill: "#7b8280",
                    fillRule: "evenodd",
                    // transform: "translate(-284.076 -266.8)",
                    stroke: 'none',

                }}
                d="m343.3,322.44l0,-0.34l-0.34,0a0.28,0.28 0 0 0 0.34,0.34zm12.88,0l0,-0.34l-0.34,0a0.28,0.28 0 0 0 0.34,0.34z" />
            <path
                style={{
                    fill: "#7b8280",
                    fillRule: "evenodd",
                    // transform: "translate(-307.359 -271.77)",
                    stroke: 'none',

                }}
                d="m371.14,328.44a0.86,0.86 0 0 0 0.08,-0.34c-0.15,0.01 -0.18,0.13 -0.14,0.25l0.06,0.09zm3.43,0a0.86,0.86 0 0 0 0.09,-0.34c-0.15,0.01 -0.18,0.13 -0.14,0.25l0.05,0.09z" />
            <path

                style={{
                    fill: "#7b8280",
                    fillRule: "evenodd",
                    // transform: "translate(-284.167 -266.8)",
                    stroke: 'none',

                }}

                d="m343.14,322.44a0.86,0.86 0 0 0 0.08,-0.34c-0.15,0.01 -0.18,0.13 -0.14,0.25l0.06,0.09zm13.05,0a0.86,0.86 0 0 0 0.08,-0.34c-0.15,0.01 -0.18,0.13 -0.14,0.25l0.06,0.09z" />
            <path
                style={{
                    fill: "#7b8280",
                    fillRule: "evenodd",
                    // transform: "translate(-304.874 -80.431)",
                    stroke: 'none',

                }}
                d="m368.14,97.44a0.86,0.86 0 0 0 0.08,-0.34c-0.15,0.01 -0.18,0.13 -0.14,0.25l0.06,0.09zm4.46,0a0.86,0.86 0 0 0 0.09,-0.34c-0.15,0.01 -0.18,0.13 -0.14,0.25l0.05,0.09z" />
            <path
                style={{
                    fill: "#7b8280",
                    fillRule: "evenodd",
                    // transform: "translate(-304.812 -492.099)",
                    stroke: 'none',

                }}
                d="m367.99,594.15c0.06,0.13 0.25,0.06 0.34,0.04a2.23,2.23 0 0 0 -0.34,-0.09l0,0.05zm4.29,0c0.06,0.13 0.25,0.06 0.34,0.04a2.23,2.23 0 0 0 -0.34,-0.09l0,0.05z" />
            <path
                style={{
                    fill: "#7b8280",
                    fillRule: "evenodd",
                    // transform: "translate(-304.812 -492.299)",
                    stroke: 'none',

                }}
                d="m367.99,594.38c0.06,0.07 0.11,0.05 0.17,0.01c-0.05,-0.04 -0.11,-0.08 -0.17,-0.01zm4.46,0c0.06,0.07 0.11,0.05 0.18,0.01c-0.06,-0.04 -0.12,-0.08 -0.18,-0.01z" />

        </svg>
    )
}
